import { ColorSystemOptions, SupportedColorScheme } from '@mui/material/styles';

import * as colors from '../constants';

const ColorSchemes: Partial<Record<SupportedColorScheme, ColorSystemOptions>> = {
  light: {
    palette: colors
  }
};

export default ColorSchemes;
